<div class="page">
  <app-voice-record
    (fileReady)="onFileReady($event)"
    >
  </app-voice-record>

  <div class="feedback" [class.loading]="loading">
    @if (first) {
      <span>Once you start recording<br>we'll provide the output here.</span>
    }
    @if (!first) {
      <span>Loading sample (takes ~0.5s)</span>
    }
    <audio #audioOutput controls></audio>
  </div>
</div>
